import React from "react";
import { Box, Button } from "@material-ui/core";
import { ObjectivesList } from "./components/ObjectivesList";
import { Alert } from "@material-ui/lab";
import { withRouter } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { withTranslation } from 'react-i18next';

function Flashboard(props) {
    const { t } = props;
    return (
        <Box>
            <Button
                variant="text"
                color="primary"
                style={{ marginBottom: 10 }}
                onClick={() => props.history.goBack()}
            >
                <ArrowBackIosIcon fontSize="small" />
                {t('flashboard.button.back')}
            </Button>
            <Alert severity="info">
                {t('flashboard.info.threshold')}
            </Alert>
            <Box sx={{ marginTop: 10 }}>
                <ObjectivesList />
            </Box>
        </Box>
    );
}

export default withRouter(withTranslation()(Flashboard));
